import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { CertificateRecordStatus } from 'app/library/certificate-record/models/certificate-record-status.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-certificates-status-filter',
    templateUrl: './certificates-status-filter.component.html',
    styleUrls: ['./certificates-status-filter.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CertificatesStatusFilterComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    statuses: { translationLabel: string; value: number }[];

    @Output()
    addedToList = new EventEmitter<IChoosenFilterInterface[]>();

    @Output()
    choosenStatuses = new EventEmitter<{ translationLabel: string; value: number }[]>();

    dataSource: MatTableDataSource<{ translationLabel: string; value: number }>;
    displayedColumns = ['name', 'buttons'];

    list: IChoosenFilterInterface[] = [];

    certificateStatuses = CertificateRecordStatus;

    constructor(private _allUsersService: AllUsersApiService, private _translateService: TranslateService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this._allUsersService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.list = filters;
            this.updateDataSource();
        });
    }

    updateDataSource(): void {
        if (this.statuses.length) {
            this.dataSource = new MatTableDataSource(
                this.statuses.map((status) => {
                    status = Object.assign(status, status, {
                        selected: this.list.some((item) => item.entity.id === status.value.toString()),
                    });

                    return status;
                })
            );
        }
    }

    addToList(status: { translationLabel: string; value: number }): void {
        this.addedToList.emit([
            ...this.list,
            {
                entity: { id: status.value.toString(), type: 'Status' },
                valueToShow: `${this._translateService.instant('GENERAL.PROPERTY.STATUS')}: ${this._translateService.instant(status.translationLabel)}`,
            },
        ]);
    }

    removeFromList(status: { translationLabel: string; value: number }): void {
        this.addedToList.emit(this.list.filter((item) => !(item.entity.id === status.value.toString() && item.entity.type === 'Status')));
    }

    onSelection(): void {
        this.choosenStatuses.emit(this.dataSource.data.filter((item: any) => item.selected));
    }
}
